var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_vm._v(" Percent: "+_vm._s(_vm.overtime.percent)+" ")]),_c('div',{staticClass:"col-4"},[_vm._v(" Hours: "+_vm._s(_vm.overtime.hours)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }